import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';
import findNotificacao from '../../service/findNotificacao';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import patchNotificacaoStatus from '../../service/patchNotificacaoStatus';



export default function NotificacaoList({onEdit}:{onEdit:(notificacao:any)=>void}) {
  const { t } = useTranslation();
  const [notificacoes, setNotificacoes] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const toast = useRef<Toast>(null);

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: 'titulo',
    sortOrder: SortOrder.DESC
  });


  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = () => {
    findNotificacao(lazyState).then(data => {setTotalRecords(data.total);setNotificacoes(data.notificacoes)}).catch(() => {setTotalRecords(0);setNotificacoes(undefined)});
  }


  const editBodyTemplate = (notificacao:any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(notificacao)} style={{background:'transparent', color:'gray', border: 'none'}} />;
  };

  const saveStatusNotificacao = (id:string, inativo:boolean) => {
    patchNotificacaoStatus(id, inativo)
    .then(()=> { loadLazyData(); toast.current!.show({severity:'success', summary: 'Sucesso', detail:'Status alterado com sucesso', life: 3000});})
    .catch(()=> {toast.current!.show({severity:'error', summary: 'Erro', detail:'Erro ao alterar status', life: 3000});});
  }
 
  const statusBodyTemplate = (notificacao:any) => {
    return <InputSwitch checked={notificacao.inativo} value={notificacao.inativo} onChange={() => { notificacao.inativo = !notificacao.inativo; saveStatusNotificacao(notificacao.id, notificacao.inativo)}} />;
  };
  
  useEffect(() => {
    loadLazyData();
  },[lazyState])

  return (
    <div>
      <Toast ref={toast} />
      <div>
        <DataTable value={notificacoes} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column field="data" sortable header={t('data')}  />
           <Column field="usuario" sortable header={t('usuario')}  />
           <Column field="titulo" sortable header={t('titulo')}  />
           <Column body={statusBodyTemplate} header={t('inativo')}  />
           <Column body={editBodyTemplate} />
        </DataTable> 
      </div>
    </div>
  )
}


